import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Error = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M12 7.75a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-4a.75.75 0 0 1 .75-.75m1 7.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0'
          fill='currentColor'
        />
        <path
          d='M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinejoin='round'
        />
      </>
    ) : (
      <>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12m10.75-3.5a.75.75 0 0 0-1.5 0v4a.75.75 0 0 0 1.5 0zM12 16.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2'
          fill='currentColor'
        />
      </>
    )}
  </IconBase>
);
